export enum TableViews {
  DIFFERENCE = 'difference',
  OPTIMISTIC = 'optimistic',
  PESSIMISTIC = 'pessimistic',
}

export const TableViewsAsIndex = {
  [TableViews.DIFFERENCE]: 0,
  [TableViews.OPTIMISTIC]: 1,
  [TableViews.PESSIMISTIC]: 2,
};

export const TRUNCATED_MONTH = {
  january: 'Jan.',
  february: 'Feb.',
  march: 'Mar.',
  august: 'Aug.',
  september: 'Sep.',
  october: 'Oct.',
  november: 'Nov.',
  december: 'Dec.',
};
